import { render, staticRenderFns } from "./clearFormatComponent.vue?vue&type=template&id=36e0d4b6&scoped=true&"
import script from "./clearFormatComponent.vue?vue&type=script&lang=js&"
export * from "./clearFormatComponent.vue?vue&type=script&lang=js&"
import style0 from "./clearFormatComponent.vue?vue&type=style&index=0&id=36e0d4b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e0d4b6",
  null
  
)

export default component.exports